import * as React from 'react'

import { compose, pure } from 'recompose'
import * as styles from './ModalTemplate.css'

interface ModalTemplateProps {
  children: React.ReactElement<any>
  handleClick: () => void
}

const ModalTemplate: React.FunctionComponent<ModalTemplateProps> = ({ children, handleClick }) => {
  return (
    <div className={styles.modalTemplate} onClick={handleClick}>
      {children}
    </div>
  )
}

export default compose<ModalTemplateProps, ModalTemplateProps>(pure)(ModalTemplate)
